import { normalizeId } from './ids';

const normalizePathSegment = normalizeId;
export const getKnownTournamentId = ({ params, location, tournamentContext } = {}) => {
  const fromParams = normalizePathSegment(params?.tournamentId);
  if (fromParams) return fromParams;

  const fromLocation =
    normalizePathSegment(location?.state?.tournamentId) ||
    normalizePathSegment(location?.state?.tournament?.id || location?.state?.tournament?._id);
  if (fromLocation) return fromLocation;

  return (
    normalizePathSegment(tournamentContext?.tournamentId) ||
    normalizePathSegment(tournamentContext?.activeTournamentId) ||
    normalizePathSegment(tournamentContext?.tournament?.id || tournamentContext?.tournament?._id) ||
    ''
  );
};

export const buildManagementScope = ({
  communityId,
  clubId,
  organizationId,
  individualTournamentId,
  entityContext,
} = {}) => {
  const normalizedCommunityId = normalizePathSegment(communityId);
  if (normalizedCommunityId) {
    return { type: 'community', id: normalizedCommunityId };
  }

  const normalizedClubId = normalizePathSegment(clubId);
  if (normalizedClubId) {
    return { type: 'club', id: normalizedClubId };
  }

  const normalizedOrganizationId = normalizePathSegment(organizationId);
  if (normalizedOrganizationId) {
    return { type: 'org', id: normalizedOrganizationId };
  }

  const normalizedIndividualTournamentId = normalizePathSegment(individualTournamentId);
  if (normalizedIndividualTournamentId) {
    return { type: 'individual-tournament', id: normalizedIndividualTournamentId };
  }

  const entityType = entityContext?.entityType;
  const entityId = normalizePathSegment(entityContext?.entityId);

  if (!entityType || !entityId) {
    return { type: '', id: '' };
  }

  if (entityType === 'community') {
    return { type: 'community', id: entityId };
  }

  if (entityType === 'club') {
    return { type: 'club', id: entityId };
  }

  if (entityType === 'organization') {
    return { type: 'org', id: entityId };
  }

  if (entityType === 'individual' || entityType === 'individual-tournament') {
    return { type: 'individual-tournament', id: entityId };
  }

  return { type: '', id: '' };
};

const buildModuleBasePath = (scope, segment, managerId) => {
  const normalizedManagerId = normalizePathSegment(managerId);

  const normalizedScopeId = normalizePathSegment(scope?.id);

  if (!scope?.type || !normalizedScopeId || !normalizedManagerId) return '';

  if (scope.type === 'individual-tournament') {
    return `/individual-tournament/${normalizedScopeId}/${segment}/${normalizedManagerId}`;
  }

  return `/${scope.type}/${normalizedScopeId}/${segment}/${normalizedManagerId}`;
};

export const buildMatchManagerFormatsPath = (scope, managerId, tournamentId) => {
  const basePath = buildModuleBasePath(scope, 'match-manager', managerId);
  const normalizedTournamentId = normalizePathSegment(tournamentId);

  if (!basePath || !normalizedTournamentId) return '';

  return `${basePath}/tournaments/${normalizedTournamentId}/match-formats`;
};

export const buildMatchManagerManualFormatPath = (scope, managerId, tournamentId) => {
  const formatsPath = buildMatchManagerFormatsPath(scope, managerId, tournamentId);

  return formatsPath ? `${formatsPath}/manual` : '';
};

export const buildMatchManagerTournamentsPath = (scope, managerId) => {
  const basePath = buildModuleBasePath(scope, 'match-manager', managerId);

  return basePath ? `${basePath}/tournaments` : '';
};

export const buildPlayerManagerTournamentPath = (scope, managerScopeId, tournamentId) => {
  const basePath = buildModuleBasePath(scope, 'player-manager', managerScopeId);
  const normalizedTournamentId = normalizePathSegment(tournamentId);

  if (!basePath || !normalizedTournamentId) return '';

  return `${basePath}/tournaments/${normalizedTournamentId}`;
};

export const buildPlayerManagerTournamentsPath = (scope, managerScopeId) => {
  const basePath = buildModuleBasePath(scope, 'player-manager', managerScopeId);

  return basePath ? `${basePath}/tournaments` : '';
};

export const buildTournamentAdminTournamentsPath = (scope, adminId) => {
  const basePath = buildModuleBasePath(scope, 'tournament-admin', adminId);

  return basePath ? `${basePath}/tournaments` : '';
};
